<template>
    <a-config-provider :locale="locale">
        <div id="app" :style="{ overflowY: about}">
            <a-spin :spinning="this.$store.state.loadding">
                <router-view />
            </a-spin>
        </div>
    </a-config-provider>
</template>

<script>
import i18n from '@/locales';
import { setDocumentTitle } from '@/utils/helpers/dom';

const { VUE_APP_TITLE } = process.env;

export default {
    data() {
        return {
            about:'auto'
        };
    },
    computed: {
        locale() {
            // 只是为了切换语言时，更新标题
            const { name } = this.$route;
            name && setDocumentTitle(i18n.t(`menu.${name}`), VUE_APP_TITLE);
            return this.$i18n.getLocaleMessage(this.$store.getters.lang).ant;
        }
    },
    watch: {
        $route(to, from) {
            this.$matomo && this.$matomo.setCustomUrl(window.location.href.replace('#/',''));
            this.$matomo && this.$matomo.trackPageView(to.meta.title);
            if (to.name == 'about') {
                this.about = 'hidden';
            } else {
                this.about = 'auto';
            }
        }
    }
};
</script>
<style lang="less">
@import (reference) '~@/assets/styles/variables.less';
@import (reference) '~@/assets/theme/theme.less';
.btn__edit,
.btn__delete {
    margin: 0 16px 0 -4px !important;
    padding: 4px;

    &:hover {
        background-color: #fff;
    }
}

.btn__edit {
    color: @primary !important;

    &:hover {
        color: @primary-hover !important;
        background-color: #fff;
    }
}
.btn__delete {
    color: @danger !important;

    &:hover {
        color: @danger-hover !important;
        background-color: #fff;
    }
}
</style>
<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
@import '@/assets/theme/theme.less';
/deep/ .ant-table-tbody .tr-bg-blue{
    background-color: #F0F6FD;
}

</style>
